import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

/**
 * @function
 * @name Badges
 * @param {String} userName - the user's name
 * @param {Boolean} showAmbassador - should show the ambassador badge
 * @param {Boolean} showNow - should show the now badge
 * Returns the markup of the seller card badges
 */

const Badges = ({userName, showAmbassador, showNow}) => {

    // now & ambassador badges take up the same space, so the now badge
    // takes precedence

    if (showNow) {

        return (
            <aside className="now-badge">{i18n.t('seller_card.badge_now')} <span className="beta-badge">{i18n.t('general.beta')}</span></aside>
        );

    } else if (showAmbassador) {

        return (
            <a href={`https://www.fiverr.com/ambassadors/${userName}`} className="ambassadors-badge">{i18n.t('general.ambassador')}</a>
        );

    }

};

Badges.propTypes = {
    userName: PropTypes.string,
    showAmbassador: PropTypes.bool.isRequired,
    showNow: PropTypes.bool.isRequired
};

export default Badges;


// WEBPACK FOOTER //
// ./src/components/badges/index.js